/* src/app/components/device-marketing/device-marketing.component.scss */
/*# sourceMappingURL=device-marketing.component.css.map */
